<template>
    <information-content @redirect='redirectLogin'>
        <template slot='title'>
            Votre mot de passe a été mis à jour.
            Vous pouvez vous connecter.
        </template>
        <template slot='label'>
            SE CONNECTER
        </template>
    </information-content>
</template>

<script>
    import InformationContent from '../components/layout/InformationContent';

    export default {
        components: {
            InformationContent},
        name: 'change-password-success',
        methods: {
            redirectLogin: function (event) {
                this.$router.push({name: 'login'});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/ChangePasswordSuccess.vue